(function () {
  const VAT_RATE = 0.20;
  const VAT_SESSION_KEY = "vat_mode_session";

  // =========================
  // STORAGE SAFE HELPERS
  // =========================
  function safeGetSession(key) {
    try { return sessionStorage.getItem(key); } catch { return null; }
  }

  function safeSetSession(key, value) {
    try { sessionStorage.setItem(key, value); } catch {}
  }

  // =========================
  // MODE
  // =========================
  function getModeDefault() {
    const root = document.documentElement;
    const allowed = root.getAttribute("data-vat-mode-allowed") || "both";
    const def = root.getAttribute("data-vat-default") || "ex";

    if (allowed === "inc") return "inc";
    if (allowed === "ex") return "ex";
    return def === "inc" ? "inc" : "ex";
  }

  function getMode() {
    const root = document.documentElement;
    const current = root.getAttribute("data-vat-mode");

    if (current === "ex" || current === "inc" || current === "both") return current;

    const saved = safeGetSession(VAT_SESSION_KEY);
    if (saved === "ex" || saved === "inc" || saved === "both") return saved;

    return getModeDefault();
  }

  function setMode(mode) {
    const root = document.documentElement;
    const allowed = root.getAttribute("data-vat-mode-allowed") || "both";

    if (allowed !== "both") mode = allowed;
    if (!["ex", "inc", "both"].includes(mode)) mode = getModeDefault();

    safeSetSession(VAT_SESSION_KEY, mode);
    root.setAttribute("data-vat-mode", mode);

    applyVatToAllPrices();
    syncAllToggles();

    window.dispatchEvent(new CustomEvent("vat:modeChanged", { detail: { mode } }));
  }

  // =========================
  // PRICE RENDERING
  // =========================
  function moneyGBPFromCents(cents) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    }).format(cents / 100);
  }

  function computeInc(ex) {
    return Math.round(ex * (1 + VAT_RATE));
  }

  function formatPerM2LabelFromExValue(exValue, mode) {
    if (!Number.isFinite(exValue) || exValue <= 0) return "";

    const incValue = exValue * (1 + VAT_RATE);
    const activeValue = mode === "inc" ? incValue : exValue;

    const roundedUp = Math.ceil(activeValue);
    const isWhole = Math.abs(activeValue - Math.round(activeValue)) < 0.0001;

    if (isWhole) {
      return `£${Math.round(activeValue)} per m²`;
    }

    return `Under £${roundedUp} per m²`;
  }

  function renderPrice(el, mode) {
    const ex = parseInt(el.getAttribute("data-price-cents"), 10);
    if (!Number.isFinite(ex)) return;

    const inc = computeInc(ex);

    // SPECIAL CASE: toolkit upsell → keep original styling, only swap value
    if (el.closest(".grp-toolkit-upsell__price-row")) {
      const value = mode === "inc" ? inc : ex;
      el.textContent = moneyGBPFromCents(value);
      return;
    }

    const isCompare = !!el.closest("[data-vat-compare], s") || el.hasAttribute("data-vat-compare");
    const isSaving = el.hasAttribute("data-vat-saving");
    const hidePill = isCompare || isSaving;

    if (mode === "ex") {
      el.innerHTML = `
        <span class="vat-display vat-display--single">
          <span class="vat-main">${moneyGBPFromCents(ex)}</span>
          ${hidePill ? "" : '<span class="vat-pill">ex. VAT</span>'}
        </span>`;
      return;
    }

    if (mode === "inc") {
      el.innerHTML = `
        <span class="vat-display vat-display--single">
          <span class="vat-main">${moneyGBPFromCents(inc)}</span>
          ${hidePill ? "" : '<span class="vat-pill">inc. VAT</span>'}
        </span>`;
      return;
    }

    // BOTH
    el.innerHTML = `
      <span class="vat-display vat-display--both">
        <span class="vat-main">${moneyGBPFromCents(inc)}</span>
        <span class="vat-sub">
          <span class="vat-sub__price">${moneyGBPFromCents(ex)}</span>
          ${hidePill ? "" : '<span class="vat-pill">ex. VAT</span>'}
        </span>
      </span>`;
  }

  function applyVatToPerM2(root) {
    const mode = getMode();
    const scope = root || document;
    const nodes = scope.querySelectorAll("[data-price-per-m2][data-price-per-m2-ex]");

    nodes.forEach((wrap) => {
      const exValue = parseFloat(wrap.getAttribute("data-price-per-m2-ex"));
      if (!Number.isFinite(exValue) || exValue <= 0) return;

      const label = formatPerM2LabelFromExValue(exValue, mode);

      const link = wrap.querySelector(".frk-card-price-link--m2");
      if (link) {
        link.textContent = label;
      }

      const overlayText = wrap.querySelector(".frk-card-m2-overlay__text");
      if (overlayText) {
        overlayText.textContent = label;
      }
    });
  }

    function applyVatToPerMetre(root) {
    const mode = getMode();
    const scope = root || document;
    const nodes = scope.querySelectorAll("[data-price-per-metre][data-price-per-metre-ex]");

    nodes.forEach((wrap) => {
      const exValue = parseFloat(wrap.getAttribute("data-price-per-metre-ex"));
      if (!Number.isFinite(exValue) || exValue <= 0) return;

      const activeValue = mode === "inc" ? exValue * (1 + VAT_RATE) : exValue;
      wrap.textContent = `£${activeValue.toFixed(2)} / metre`;
    });
  }

  function applyVatToAllPrices(root) {
    const mode = getMode();
    document.documentElement.setAttribute("data-vat-mode", mode);

    const scope = root || document;
    const nodes = scope.querySelectorAll("[data-vat-price][data-price-cents]");
    nodes.forEach(el => renderPrice(el, mode));

    applyVatToPerM2(scope);
    applyVatToPerMetre(scope);
  }

  // =========================
  // TOGGLE SYSTEM
  // =========================
  function syncAllToggles() {
    const mode = getMode();

    document.querySelectorAll("[data-vat-toggle-input]").forEach(input => {
      input.checked = mode === "inc";
    });
  }

  document.addEventListener("change", function (e) {
    const input = e.target.closest("[data-vat-toggle-input]");
    if (!input) return;

    const mode = input.checked ? "inc" : "ex";
    setMode(mode);
  });

  // =========================
  // AUTO DOM WATCH
  // =========================
  function observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (!m.addedNodes) continue;

        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

             if (node.matches?.("[data-vat-price][data-price-cents]")) {
            renderPrice(node, getMode());
          } else if (node.querySelector?.("[data-vat-price][data-price-cents]")) {
            applyVatToAllPrices(node);
          } else if (node.matches?.("[data-price-per-m2][data-price-per-m2-ex]")) {
            applyVatToPerM2(node.parentElement || document);
          } else if (node.querySelector?.("[data-price-per-m2][data-price-per-m2-ex]")) {
            applyVatToPerM2(node);
          } else if (node.matches?.("[data-price-per-metre][data-price-per-metre-ex]")) {
            applyVatToPerMetre(node.parentElement || document);
          } else if (node.querySelector?.("[data-price-per-metre][data-price-per-metre-ex]")) {
            applyVatToPerMetre(node);
          }

          if (node.querySelector?.("[data-vat-toggle-input]")) {
            syncAllToggles();
          }
        });
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // =========================
  // THEME EVENTS
  // =========================
  function hookThemeEvents() {
    const refresh = () => {
      applyVatToAllPrices();
      syncAllToggles();
    };

    document.addEventListener("cart:refresh", refresh);
    document.addEventListener("cart:updated", refresh);
    document.addEventListener("shopify:section:load", refresh);
  }

  // =========================
  // INIT
  // =========================
  document.addEventListener("DOMContentLoaded", function () {
    applyVatToAllPrices();
    syncAllToggles();
    observeDomChanges();
    hookThemeEvents();
  });

  // =========================
  // DEBUG
  // =========================
  window.__VAT = {
    getMode,
    setMode,
    applyVatToAllPrices,
    applyVatToPerM2,
    applyVatToPerMetre
  };
})();